export default "__VITE_ASSET__DQJZoplY__"